$(document).on('turbolinks:load', function () {
    $.fancybox.destroy();
});

$(document).on('turbolinks:load', function () {
    $('.js-modal-confirm-form').fancybox({
        src: '#modal-confirm-form',
        type: 'inline'
    });
});